export const SPOTIFY_PLAYLISTS_CHUNK_SIZE = 50;
export const SPOTIFY_PLAYLIST_TRACKS_CHUNK_SIZE = 50;
export const SPOTIFY_PLAYLIST_TRACKS_DELETE_CHUNK_SIZE = 100;
